module.exports = __webpack_public_path__ + "img/rotate-right.3a542360.png";